export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StoryThumbnail.vue?vue&type=template&id=3e2aef84&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/StoryThumbnail.vue?vue&type=template&id=3e2aef84&
// module id = 1037
// module chunks = 0